import styled from 'styled-components';

import { IconButton, Menu, spaceMixin, TooltipPopper } from '@zillow/constellation';

const DROPDOWN_MENU_WIDTH = '278px';

export const StyledNavigationDropdownMenu = styled(Menu)`
  width: ${DROPDOWN_MENU_WIDTH};
  max-width: ${DROPDOWN_MENU_WIDTH};
  border-radius: 12px;
`;

export const StyledTooltipPopper = styled(TooltipPopper)`
  cursor: pointer;
`;

export const StyledIconButton = styled(IconButton)`
  background-color: transparent !important;
  width: ${spaceMixin('sm')};
  height: ${spaceMixin('sm')};
  padding: 0px;
  overflow: hidden;
`;
